module.exports = __webpack_public_path__ + "img/fr.2f6435a1.png";